<template>
  <div class="col-6 card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">{{ title }}</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <form class="needs-validation" @submit.prevent="save">
          <h5 class="text-center mx-3 mb-3">
            * Para crear usuarios de tipo asesor técnico o distribuidor deberá dirigirse al formulario específico dentro
            del menu de Administrador
          </h5>

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Nombre (*) </label>

                <el-input v-model="formData.name" v-validate="modelValidations.name" name="name" placeholder="Nombre">
                </el-input>

                <small v-show="name.invalid" class="text-danger">
                  {{ getError('name') }}
                </small>
              </div>
            </div>

            <div v-if="modifyEmail" class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Email (*) </label>

                <el-input v-model="formData.email" v-validate="modelValidations.email" name="email" placeholder="Email">
                </el-input>

                <small v-show="email.invalid" class="text-danger">
                  {{ getError('email') }}
                </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Rol (*) </label>

                <el-select
                  v-model="formData.role"
                  v-validate="modelValidations.role"
                  :disabled="checkIfNotAllowed"
                  autocomplete="off"
                  filterable
                  name="role"
                  placeholder="Seleccione el rol"
                >
                  <el-option
                    v-for="option in rolesOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>
                </el-select>

                <small v-show="role.invalid" class="text-danger">
                  {{ getError('role') }}
                </small>
              </div>
            </div>

            <server-error :server-errors="serverErrors"></server-error>

            <div class="col-md-12 text-right">
              <base-button native-type="submit" type="primary">Guardar</base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { Select, Option } from 'element-ui';
import ServerError from '../../../components/ServerError';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ServerError,
  },

  props: {
    title: {
      type: String,
      default: 'Agregar nuevo usuario',
    },

    modifyEmail: {
      type: Boolean,
      default: true,
    },

    serverErrors: {
      type: Array,
      default: () => {
        return [];
      },
    },

    user: {
      type: Object,
      default: () => {
        return {
          name: null,
          email: null,
          role: null,
        };
      },
    },
  },

  data() {
    return {
      validated: false,
      roles: [],
      formData: {
        name: this.user.name,
        email: this.user.email,
        role: this.user.role,
      },

      modelValidations: {
        name: {
          required: true,
          min: 3,
        },

        email: {
          required: true,
          min: 5,
          email: true,
        },

        role: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['name', 'email', 'role']),
    checkIfNotAllowed() {
      return this.formData.role !== null && this.getRoles().findIndex((r) => r.id === this.formData.role) === -1;
    },

    rolesOptions() {
      let roles = this.getRoles();
      if (this.checkIfNotAllowed) {
        roles = this.roles;
      }
      return this.$selectOptions(roles, { sort: true, label: 'label' });
    },
  },

  mounted() {
    this.fetchRoles();
  },

  methods: {
    fetchRoles() {
      this.$services
        .resource('roles')
        .get()
        .then((res) => res.data.data)
        .then((data) => (this.roles = data.roles));
    },

    getRoles() {
      return this.roles.filter((item) => item.name !== 'seller' && item.name !== 'distributor');
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
        }
      });
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>
